// extracted by mini-css-extract-plugin
export default {"test_card":"PartSurveyReport_test_card__wkLJV","btn_print":"PartSurveyReport_btn_print__lOog1","div_print":"PartSurveyReport_div_print__XgS0E"};